module.exports = __webpack_public_path__ + "img/share_img.c7817078.png";